import { vehicleModelsSlice } from "./vehicleModelsSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = vehicleModelsSlice;
export const moduleUrl = "/api/appmasterdata/vehicleModels";

export const setValidationErrors = actions.setValidationErrors;

export const getVehicleModels = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getVehicleModel = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const saveVehicleModel = (item: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, item, id);
export const deleteVehicleModel = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearVehicleModel = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);

export const getFilters = () => defaultActions.getFilters(moduleUrl, actions);
export const setFilter = (filters: any) => defaultActions.setFilters(filters, actions);
